module.exports = __webpack_public_path__ + "img/8A.b10ecfec.jpg";